module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "atlante-geochimico gv-color-scheme"
  }, [_vm._c('div', {
    staticClass: "ag-title gv-color-scheme",
    attrs: {
      "id": "ag-title"
    }
  }, [_vm._v("\n    Atlante Geochimico\n    "), _vm._c('button', {
    class: _vm.toggleCollapseClass(),
    attrs: {
      "size": "mini",
      "title": "Nascondi Pannello"
    },
    on: {
      "click": _vm.hidePanel
    }
  })]), _vm._v(" "), _vm._c('div', {
    staticClass: "ag-wrapper gv-color-scheme",
    attrs: {
      "id": "ag-wrapper"
    }
  }, [_vm._c('el-select', {
    attrs: {
      "placeholder": "Seleziona Elemento",
      "filterable": "",
      "size": "mini"
    },
    on: {
      "change": _vm.onChange
    },
    model: {
      value: (_vm.livello),
      callback: function($$v) {
        _vm.livello = $$v
      },
      expression: "livello"
    }
  }, _vm._l((_vm.livelli), function(item) {
    return _vm._c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.title
      }
    }, [_vm._c('span', {
      staticStyle: {
        "font-size": "16px"
      }
    }, [_vm._v(_vm._s(item.title))])])
  })), _vm._v(" "), _vm._c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLegend),
      expression: "showLegend"
    }],
    staticClass: "ag-legend"
  }, [_vm._c('gv-iframe-panel', {
    staticClass: "gv-iframe-panel",
    attrs: {
      "src": _vm.legendUrl,
      "height": "237",
      "width": "249"
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-74c78892!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AtlanteGeochimicoLivelli.vue
// module id = 878
// module chunks = 39